<template>
  <v-app>
    <public-navigation-drawer
      :open="drawer"
      @close="(value) => (drawer = value)"
      :items="navigationItems"
    />
    <public-app-bar
      :notification-count="notificationCount"
      @click="drawer = !drawer"
    />

    <v-main :class="{ 'mt-8': !tablet && !mobile, 'mt-16': isChat && mobile }">
      <div
        :class="{
          'body-container': true,
          'chat-position-fixed': isChat && mobile,
        }"
      >
        <app-updated-alert />

        <transition name="fade" mode="out-in">
          <keep-alive
            :include="['ProviderPermissions', 'Connections', 'AddConnection']"
          >
            <router-view />
          </keep-alive>
        </transition>
      </div>
    </v-main>
    <bottom-navigation />
    <global-modals />
    <hubspot-chat-bot v-if="$p(permissions.system.hubspot)" />
    <force-logout-check v-if="$p(permissions.system.logout)" />
    <websockets />
    <vue-snotify />
  </v-app>
</template>

<script>
import { LAYOUT_DEFAULT } from "Shared/store/ui";
import SideNav from "../components/SideNav/SideNav";
import TopNav from "../components/TopNav";
import GlobalModals from "Public/components/GlobalModals";
import HubspotChatBot from "Public/components/HubspotChatBot";
import ForceLogoutCheck from "Public/components/ForceLogoutCheck";
import Websockets from "Public/components/Websockets";
import PublicNavigationDrawer from "Public/components/NavigationDrawer";
import PublicAppBar from "Public/components/AppBar";
import BottomNavigation from "Public/components/BottomNavigation";
import userMixin from "Shared/mixins/userMixin";
import { parseNavigationItems } from "Public/components/NavigationDrawer/utils/parseNavigationItems";
import isMobile from "PublicHelpers/isMobile";
import isTablet from "PublicHelpers/isTablet";
import checkMobileMixin from "Shared/mixins/checkMobileMixin";
import checkTabletMixin from "Shared/mixins/checkTabletMixin";
import checkIsChatMixin from "Shared/mixins/checkIsChatMixin";
import { permissions } from "Consts/permissions";
import AppUpdatedAlert from "Public/components/GlobalModals/AppUpdatedAlert";

export default {
  name: LAYOUT_DEFAULT,
  mixins: [userMixin, checkMobileMixin, checkTabletMixin, checkIsChatMixin],

  components: {
    AppUpdatedAlert,
    BottomNavigation,
    PublicAppBar,
    PublicNavigationDrawer,
    Websockets,
    ForceLogoutCheck,
    HubspotChatBot,
    GlobalModals,
    TopNav,
    SideNav,
  },
  watch: {
    user: {
      handler() {
        this.updateNavigationItems();
      },
      deep: true,
    },
  },
  data() {
    return {
      permissions,
      drawer: !isMobile() && !isTablet(),
      navigationItems: [],
      notificationCount: false,
    };
  },
  methods: {
    updateNavigationItems() {
      this.navigationItems = parseNavigationItems(this.user);
      const statsSum = this.navigationItems
        .filter((item) => !!item?.stat)
        .map((item) => item.stat)
        .reduce((a, b) => a + b, 0);
      const proStatSum = this.navigationItems
        .filter((item) => !!item?.proStat)
        .map((item) => item.proStat)
        .reduce((a, b) => a + b, 0);
      this.notificationCount = statsSum + proStatSum;
    },
  },
  created() {
    this.updateNavigationItems();
  },
};
</script>

<style>
html {
  overflow-y: auto !important;
}
</style>
